export enum ProfTestEventType {
  proforientationTest = 'proforientation_test',
}

export enum ProfTestEvent {
  clickButtonTakeTheTest = 'click_button_take_the_test',
}
